"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a "deferred" object that can be resolved later by the same code that created the promise.
 * "Deferred" is syntactic sugar for saving a promise's `resolve` function onto a closed scope
 * (in order to manually invoke it later), but our compiler does not treat this pattern nicely.
 *
 * This replicates the basic Deferred functionality of the Q library, but uses an ES6 promise,
 * thus avoiding us having to take a dependency on Q.
 */
var SimpleDeferred = /** @class */ (function () {
    function SimpleDeferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.internalResolve = resolve;
            _this.internalReject = reject;
        });
    }
    Object.defineProperty(SimpleDeferred.prototype, "resolve", {
        get: function () {
            return this.internalResolve;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SimpleDeferred.prototype, "reject", {
        get: function () {
            return this.internalReject;
        },
        enumerable: true,
        configurable: true
    });
    return SimpleDeferred;
}());
exports.SimpleDeferred = SimpleDeferred;
//# sourceMappingURL=SimpleDeferred.js.map